import { render, staticRenderFns } from "./Associated.vue?vue&type=template&id=61b6db17&scoped=true&"
import script from "./Associated.vue?vue&type=script&lang=js&"
export * from "./Associated.vue?vue&type=script&lang=js&"
import style0 from "./Associated.vue?vue&type=style&index=0&id=61b6db17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b6db17",
  null
  
)

export default component.exports